module.exports = __webpack_public_path__ + "static/turquia-028-52cfbcac6613da1cb85fcd516af4c901.jpg";